import { useTranslation } from "react-i18next";
import type { AgentType } from "../types";
import { BrunaAvatar } from "@/core/components/bruna/bruna-avatar";

type AssistantIdentityProps = {
  agentType?: AgentType | null;
};

/**
 * Identifica a Bruna em cada interação do chat. O modo que tratou o turno
 * (operação, estratégia, experiência) não aparece mais no nome (PED-14564):
 * fica só em `data-agent-type`, para inspeção e testes. Sem selo "Beta", como
 * no Figma.
 */
export function AssistantIdentity({ agentType }: AssistantIdentityProps) {
  const [translate] = useTranslation(["core"]);

  return (
    <div
      className="mb-2 flex items-center gap-2"
      data-testid="assistant-identity"
      data-agent-type={agentType ?? undefined}
    >
      <BrunaAvatar size={20} />
      <span className="text-sm font-semibold text-darkgray-700">
        {translate("chatbot-agent-facilities-name")}
      </span>
    </div>
  );
}
